// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2oWOd","footer":"ModalInfo_footer__OwBlh"};